import {Directive, HostListener, OnDestroy, OnInit} from "@angular/core";
import {HeaderVisibilityService} from "../services/header-visibility.service";
import {WINDOW_RESIZED$} from "../../app.component";
import {filter, first} from "rxjs/operators";

@Directive({
    selector: 'input',
    standalone: false
})
export class HideHeaderOnInputFocusDirective {

	constructor(private headerVisibilityService: HeaderVisibilityService) {
	}

	@HostListener('focus')
	onFocus() {
		WINDOW_RESIZED$.asObservable().pipe(first(), filter(width => width <= 1024)).subscribe(width => {
			this.headerVisibilityService.setVisibility(false);
		});
	}
}
